import { Box, Button, Stack, useTheme, useMediaQuery } from "@mui/material";

interface InvoicePaginationControlsProps {
  hasMore: boolean;
  hasStartingAfter: boolean;
  onFirstPage: () => void;
  onNextPage: () => void;
}

const InvoicePaginationControls = ({
  hasMore,
  hasStartingAfter,
  onFirstPage,
  onNextPage,
}: InvoicePaginationControlsProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box display="flex" sx={{ p: { xs: 1.5, sm: 2 }, flexDirection: { xs: "column", sm: "row" }, gap: { xs: 1.5, sm: 0 } }}>
      <Box sx={{ flexGrow: { xs: 0, sm: 1 } }}>&nbsp;</Box>
      <Stack direction="row" spacing={{ xs: 1.5, sm: 2 }} sx={{ width: { xs: "100%", sm: "auto" }, justifyContent: { xs: "stretch", sm: "flex-end" } }}>
        {hasStartingAfter && (
          <Button 
            variant="contained" 
            onClick={onFirstPage}
            sx={{
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
              px: { xs: 2, sm: 3 },
              py: { xs: 1, sm: 1.5 },
              flex: { xs: 1, sm: "none" },
            }}
          >
            First Page
          </Button>
        )}
        {hasMore && (
          <Button 
            variant="contained" 
            onClick={onNextPage}
            sx={{
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
              px: { xs: 2, sm: 3 },
              py: { xs: 1, sm: 1.5 },
              flex: { xs: 1, sm: "none" },
            }}
          >
            Next Page
          </Button>
        )}
      </Stack>
    </Box>
  );
};

export default InvoicePaginationControls;

